export default __webpack_public_path__ + "static/media/background.1befc03c.jpg";